// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b97fb299","239":"bc97b7c2","455":"a08e7bd8"}[chunkId] + ".chunk.js";
};